module.exports = __webpack_public_path__ + "static/img/7.5b60363.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/3/1/zh/7.png
// module id = HuS6
// module chunks = 0